export class Timer {
    constructor(interval, totalTime,callback,stopCallback) {
        this.interval = interval; // 循环调用时间间隔，单位毫秒
        this.totalTime = totalTime; // 总时间，单位毫秒
        this.timerId = null; // 用于存储setTimeout或setInterval的ID
        this.elapsedTime = 0; // 已过去的时间，单位毫秒
        this.isRunning = false; // 定时器是否正在运行
        this.callback = callback; // 定时器是否正在运行
        this.stopCallback = stopCallback; // 定时器是否正在运行
    }

    start() {
        if (this.isRunning) return; // 如果定时器已经在运行，则不启动新的定时器

        this.isRunning = true;
        this.elapsedTime = 0; // 重置已过去的时间
        this.timerId = setInterval(() => {
            this.elapsedTime += this.interval;
            // 执行回调函数
            if (this.callback){
                this.callback();
            }
            if (this.elapsedTime >= this.totalTime) {
                this.stop(); // 如果达到总时间，则停止定时器
            }
        }, this.interval);
    }

    stop(stopCallback) {
        if (!this.isRunning) return; // 如果定时器没有运行，则不停止
        clearInterval(this.timerId); // 清除定时器
        this.isRunning = false; // 设置状态为未运行
        if (stopCallback){
            stopCallback();
            return;
        }
        if (this.stopCallback){
            this.stopCallback();
        }
    }
}



// 你可以在适当的时候调用myTimer.stop()来停止定时器。
